var API = {
    ajaxRequest: null,

    get(url, timeout) {
        return new Promise(resolve => {
            if (typeof bt !== 'undefined' && bt) {
                $.ajaxSetup({ headers: { 'Authorization': bt } });
            }
            const options = {
                type: 'GET',
                url: url,
                contentType: 'application/json',
                success: function (data) {
                    resolve(data);
                },
                error: function (error) {
                    if (typeof window.log === 'function') {
                        window.log(['API.get', 'error', url, error.responseJSON]);
                    }
                    console.log(error.responseText);
                    resolve({ ajaxError: true, error: error }); // geef jqXHR door
                }
            };
            if (timeout > 0) options.timeout = timeout;
            $.ajax(options);
        });
    },

    post(url, data, timeout = 0, preInternetCheck = false) {
        return new Promise(async resolve => {
            if (preInternetCheck) {
                let result = await API.get('/api/local/pos/sale/data/status', 1000);
                if (result.status != 200) {
                    resolve({ ajaxError: true, error: 'no internet' });
                    return;
                }
            }

            if (typeof data !== 'string') {
                data = JSON.stringify(data);
            }

            let headers = { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') };
            if (typeof bt !== 'undefined' && bt) {
                headers.Authorization = bt;
            }
            $.ajaxSetup({ headers });

            const options = {
                type: 'POST',
                url: url,
                data: data,
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                success: function (response) {
                    resolve(response);
                },
                error: function (error) {
                    if (typeof window.log === 'function') {
                        window.log(['API.post', 'error', data, url, error.responseJSON]);
                    }
                    console.log(error.responseText);
                    resolve({ ajaxError: true, error: error }); // geef jqXHR door
                }
            };
            if (timeout > 0) options.timeout = timeout;

            API.ajaxRequest = $.ajax(options);
        });
    },
};

function genResponse(err) {
    if (!err) return err;
    if (err.response !== undefined) return err.response; // al axios-style
    if (typeof err.status !== 'undefined') {
        return { status: err.status, data: (err.responseJSON !== undefined ? err.responseJSON : err.responseText) };
    }
    return err;
}

// Wrappers die inline blijven werken en dezelfde signature behouden
var APIGet = function (url, callback, callbackError = false, timeout = 5000) {
    const timestamp = (typeof moment !== 'undefined' ? moment().valueOf() : Date.now());
    API.get(url, timeout).then(function (res) {
        if (res && res.ajaxError) {
            if (typeof callbackError === 'function') callbackError(genResponse(res.error));
            return;
        }
        if (typeof callback === 'function') callback(res, timestamp);
    });
};

var APIPost = function (url, data, callback, callbackError = false, timeout = 5000) {
    const timestamp = (typeof moment !== 'undefined' ? moment().valueOf() : Date.now());
    API.post(url, data, timeout).then(function (res) {
        if (res && res.ajaxError) {
            if (typeof callbackError === 'function') callbackError(genResponse(res.error));
            return;
        }
        if (typeof callback === 'function') callback(res, timestamp);
    });
};

window.API = API;
window.APIGet = APIGet;
window.APIPost = APIPost;